export default {
    methods: {
        /*
         * This new helper method can be used to simplify translation calls.
         * Instead of calling multiple times in Vue component for translations as:
         * this.$t('averylongnameformysection.subsection.title'), it can be simplified as this.$tkey('subsection.title')
         * as long as localizationKey is passed as an option to the Vue component. See furniture-editor.vue for more examples.
         * */
        $tkey(key, ...args) {
            if (!this.$options.localizationKey) return this.$t(key, ...args);
            return this.$t(`${this.$options.localizationKey}.${key}`, ...args);
        },
        $tckey(key, ...args) {
            if (!this.$options.localizationKey) return this.$t(key, ...args);
            return this.$t(`${this.$options.localizationKey}.${key}`, ...args);
        },
    },
};
